import React, { useState, Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { useForm, Controller } from "react-hook-form";
import '../../style/UserStyleSheet.css';
import Switch from '@material-ui/core/Switch';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker
} from "@material-ui/pickers";

import DateFnsUtils from '@date-io/date-fns';
import Typography from '@material-ui/core/Typography';
import { SelectItem } from './types/locationTypes';
import BreakSelect from './hoursofservice/BreakSelect'
import { createBreakDurations, createMaxBreakDelays } from './hoursofservice/helpers'

const useStyles = makeStyles((theme) => ({
    grid: {
        // margin: theme.spacing(0),
        // flexGrow: 0,
        display: 'flex',
        justifyContent: 'space-around',
        maxWidth: `100%`,
        //flexBasis: `100%`
    },
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    heading: {
        fontSize: 30,
        padding: theme.spacing(0, 0, 2, 0)
    },
    margin: {
        margin: theme.spacing(1)
    },
    extendedIcon: {
        fontSize: 'small',
        color: theme.palette.primary.light,
    },
    main: {
        padding: theme.spacing(0, 20, 0, 50)
    },
    mainGrid: {
        width: '100%',
        padding: theme.spacing(0, 20, 0, 50)
    },
    mainTop: {
        padding: theme.spacing(5, 20, 0, 50)
    },
    textField: {
        backgroundColor: '#ECECEC',
        height: 30
    },
    textFieldLable: {
        fontSize: 15,
        color: '#949494',
        paddingTop: "11px"
    },
    selectField: {
        backgroundColor: '#ECECEC',
        height: 40
    },
    formBtn: {
        margin: theme.spacing(0, 1, 0, 1),
        width: '100px',
        height: '40px'
    },
    formLeft: {
        margin: theme.spacing(0, 0, 0, 50)
    },
    loading: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paperModal: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2, 4, 3),
    },
    alertRoot: {
        marginTop: 24
    },
    headingAlert: {
        padding: theme.spacing(0, 0, 2, 0),
    },
    textFieldRoot: {
        width: '100%'
    },
    textFieldInput: {
        backgroundColor: '#ECECEC',
        color: 'black',
        height: '40px'
    },
    helpText: {
        color: 'red',
        padding: theme.spacing(0, 0, 0, 2)
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    }
}));


function AddEditLocationHoursRow(props: {
    hd: string,
    errorsFrom: any,
    nameFrom: any,
    setFromValue: (value: MaterialUiPickersDate | null) => any,
    errorsTo: any,
    nameTo: string,
    setToValue: (value: MaterialUiPickersDate | null) => any,
    
    businessOpenName: string,
    businessOpenValue: boolean,
    control: any
}): JSX.Element {

    const classes = useStyles();

    //const handleOnChangeOpenOrClose = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) : void => {
    //    setIsBusinessOpen(checked);
    //}
    return (
        <React.Fragment>

            <Grid container item xs={12} spacing={1} className={classes.grid} >
                <Grid item xs={6} lg={5}>
                    <div className={classes.textFieldLable}><b>{props.hd}</b></div>
                </Grid>
                <Grid item xs={6} lg={3}>
                    <Typography component="div">
                        <Grid component="label" container alignItems="center" spacing={1}>
                            <Grid item>Closed</Grid>
                            <Grid item>
                                <Controller
                                    name={props.businessOpenName}
                                    control={props.control}
                                    defaultValue={true}
                                    render={({ onChange, onBlur, value }) => (
                                        <Switch color="primary" checked={value} onChange={(e, value) => {
                                            onChange(value);
                                            if (!value) {
                                                props.setFromValue(null);
                                                props.setToValue(null);
                                            }
                                        }} />)
                                    }

                                />
                            </Grid>
                            <Grid item>Open</Grid>
                        </Grid>
                    </Typography>
                </Grid>
                <Grid item xs={6} lg={2}>
                    <Fragment>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Controller
                                render={({ onChange, onBlur, value }) => (
                                    <KeyboardTimePicker value={value} onChange={(date, value) => { onChange(date); }}
                                        ampm={false}
                                        invalidDateMessage="Invalid"
                                        InputAdornmentProps={{
                                            style: { display: 'none' }
                                        }}
                                        error={props.errorsFrom ?? false}
                                        helperText={props.errorsFrom ? props.errorsFrom.message : ''}
                                        inputVariant='outlined'

                                        disabled={!props.businessOpenValue}
                                        mask="__:__"
                                    />)
                                }
                                control={props.control}
                                inputProps={{ style: { textAlign: 'center', borderColor: '#ECECEC' } }}
                                defaultValue={null}
                                rules={{
                                    validate: (value) => {
                                        if (props.businessOpenValue && !value) { return "Required" }
                                    }
                                }}
                                name={props.nameFrom}
                            />

                        </MuiPickersUtilsProvider>
                    </Fragment>
                </Grid>
                <Grid item xs={6} lg={2}>
                    <Fragment>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Controller
                                render={({ onChange, onBlur, value }) => (
                                    <KeyboardTimePicker value={value} onChange={(date, value) => { onChange(date); }}
                                        ampm={false}
                                        invalidDateMessage="Invalid"
                                        InputAdornmentProps={{
                                            style: { display: 'none' }
                                        }}
                                        error={props.errorsTo ?? false}
                                        helperText={props.errorsTo ? props.errorsTo.message : ''}
                                        inputVariant='outlined'

                                        disabled={!props.businessOpenValue}
                                        mask="__:__"
                                    />)
                                }
                                control={props.control}
                                defaultValue={null}
                                rules={{
                                    validate: (value) => {

                                        if (props.businessOpenValue && !value) {
                                            return "Required"
                                        }

                                    }
                                }}
                                name={props.nameTo}
                            />
                        </MuiPickersUtilsProvider>
                    </Fragment>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}
export default React.memo(AddEditLocationHoursRow);